import { optionStatusBin } from '../../../pages/daf/Adm/Dominios/utils/optionStatusBin';
import { ExportSheet } from '../core';
import { DataPreparer } from '../factory';

export class ListagemFluxosAdminModelosExportPreparer implements DataPreparer {
  async prepareForExport(selectedItems: any[]): Promise<ExportSheet[]> {
    const mainSheetData = selectedItems.map((item) => ({
      id: item.id,
      status: optionStatusBin.find((opt) => opt.value === item.status)?.label,
      nomeModelo: item.nomeModelo,
      descricao: item.descricao,
      setor: item.setorNome,
      dominio: item.dominioNome,
      etapas: item.etapas,
      linkMaisInfo: item.linkMaisInfo,
      observacao: item.observacao,
      usuarioRegistro: item.usuarioRegistro?.nomeCompleto || 'N/A',
      dataRegistro: item.dataRegistro,
      usuarioAtualizacao: item.usuarioAtualizacao?.nomeCompleto || 'N/A',
      dataUltimaAtualizacao: item.dataUltimaAtualizacao,
      nEdicoes: item.nEdicoes || 0,
    }));

    const mainSheet: ExportSheet = {
      name: 'Fluxos Administrativos',
      columns: {
        id: 'ID',
        status: 'Status',
        nomeModelo: 'Modelo',
        descricao: 'Descrição',
        setor: 'Setor Responsável',
        dominio: 'Domínio',
        etapas: 'Etapas',
        linkMaisInfo: 'Link',
        observacao: 'Observações',
        usuarioRegistro: 'Responsável pelo Registro',
        dataRegistro: 'Data de Registro',
        usuarioAtualizacao: 'Responsável Ult. Atualização',
        dataUltimaAtualizacao: 'Última Atualização',
        nEdicoes: 'Edições',
      },
      data: mainSheetData,
    };

    return [mainSheet];
  }
}
